var r=function(r,a){for(var t=-1,e=Array(r);++t<r;)e[t]=a(t);return e};export{r as default};
//# sourceMappingURL=_baseTimes.js.map
